import StorefrontMock from "@/components/landing/ResponsiveShowcase/StorefrontMock";
import { DeviceFrame } from "@/components/landing/shared";

interface DesktopDeviceProps {
	shopLabel: string;
}

function DesktopDevice(prop: DesktopDeviceProps) {
	const { shopLabel } = prop;
	return (
		<DeviceFrame className="w-76 rounded-xl sm:w-sm">
			<StorefrontMock cols={3} showNavLinks shopLabel={shopLabel} />
		</DeviceFrame>
	);
}

export default DesktopDevice;
